import axiosInstance from "../../../middlewares/axiosInstance";
import { AxiosResponse } from "axios";

interface ListParams {
  searchQuery?: string;
  filters?: any[];
  sortField?: string;
  sortOrder?: "asc" | "desc";
  pageIndex?: number;
  pageSize?: number;
}

interface ListResponse {
  data: any[];
  metadata: {
    total: {
      value: number;
    };
    took: number;
    timed_out: boolean;
    max_score: number | null;
  };
}

class SupplierService {
  async listSuppliers(params: ListParams): Promise<ListResponse> {
    const response = await axiosInstance.post(
      "/business-admin/suppliers/list",
      {
        ...params,
      }
    );
    return response.data.data;
  }

  async getSupplier(id: string): Promise<AxiosResponse<any>> {
    return axiosInstance.post("/business-admin/suppliers/get", { id });
  }

  async createSupplier(data: any): Promise<AxiosResponse<any>> {
    return axiosInstance.post("/business-admin/suppliers/create", data);
  }

  async updateSupplier(data: any): Promise<AxiosResponse<any>> {
    const response = await axiosInstance.post(
      "/business-admin/suppliers/update",
      {
        ...data,
      }
    );

    return response.data;
  }

  async deleteSupplier(id: string): Promise<AxiosResponse<any>> {
    return axiosInstance.post("/business-admin/suppliers/delete", { _id: id });
  }
}

export const supplierService = new SupplierService();
